import * as React from 'react';
import { Character } from '../../constants';

interface IExpandingMenuItemProps extends React.PropsWithChildren {
	guttered: boolean;
	onClick?: (a: any) => any;
	selected?: boolean;
}

export class ExpandingMenuItem extends React.Component<IExpandingMenuItemProps> {

	public render() {
		const Comp = this.props.onClick ? 'button' : 'div';

		return <Comp
			className={`expanding-menu-item${this.props.onClick ? ' expanding-menu-item-actionable' : ''}`}
			onClick={(e: any) => this.props.onClick && this.props.onClick(e)}>
			{this.props.guttered && <div className="expanding-menu-gutter" >{this.props.selected && Character.Tick}</div>}
			<div className="expanding-menu-option">{this.props.children}</div>
		</Comp>;
	}
}
